import React, { useEffect, useState } from 'react'
import { LoaderProps } from './types'
import { GET_MERCHANT_INTEGRATIONS } from 'router/queries'
import { useSession } from 'packages/@slerp/accounts'
import { useQuery } from '@apollo/client'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import { MerchantIntegration } from '@slerp/controls'

export const MerchantIntegrationsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const { integrations, setIntegrations } = useMerchant()

  const [isLoaded, setIsLoaded] = useState(false)

  const { loading } = useQuery<{ partners_merchants: MerchantIntegration[] }>(
    GET_MERCHANT_INTEGRATIONS,
    {
      variables: { merchantId: merchant?.id },
      skip: !merchant?.id || integrations?.length > 0,
      onCompleted: (data) => {
        if (!data) {
          return
        }

        setIntegrations(data.partners_merchants)
      }
    }
  )

  useEffect(() => {
    setIsLoaded(isParentLoaded && !loading)
  }, [loading, isParentLoaded])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
